import React from "react";
import { useTranslation } from "react-i18next";
import type { DealResponseDto } from "../../../types/types";
import {
  formatComponentLabel,
  formatMoney,
  getAggregatedComponents,
  sortComponents,
} from "./dealCardHelpers";

interface DealPaymentBreakdownProps {
  deal: DealResponseDto;
  currency: string;
}

export const DealPaymentBreakdown: React.FC<DealPaymentBreakdownProps> = ({
  deal,
  currency,
}) => {
  const { t, i18n } = useTranslation("chat");

  const components = sortComponents(getAggregatedComponents(deal));
  if (components.length === 0) return null;

  const total = components.reduce((sum, c) => sum + c.resolvedAmount, 0);

  return (
    <>
      <div className="my-4 flex items-center gap-3">
        <div className="flex-1 border-t border-gray-200" />
        <span className="text-xs text-gray-500">{t("paymentDetails")}</span>
        <div className="flex-1 border-t border-gray-200" />
      </div>

      <div className="rounded-2xl bg-gray-50 p-4">
        <ul className="space-y-3">
          {components.map((item) => (
            <li
              key={item.componentType}
              className="flex items-center justify-between gap-4 text-sm"
            >
              <span className="text-gray-500">
                {formatComponentLabel(item.componentLabel || item.componentType)}
              </span>
              <span className="text-right tabular-nums text-gray-900">
                {formatMoney(item.resolvedAmount, currency, i18n.language)}
              </span>
            </li>
          ))}
        </ul>

        <div className="mt-3 flex items-center justify-between gap-4 border-t border-gray-200 pt-3">
          <span className="text-sm font-bold text-gray-900">{t("total")}</span>
          <span className="text-right text-sm font-bold tabular-nums text-gray-900">
            {formatMoney(total, currency, i18n.language)}
          </span>
        </div>
      </div>
    </>
  );
};
